document.addEventListener("DOMContentLoaded", function() {
    var typ_nemovitosti = document.getElementById('typ_nemovitosti');
    var typ_subtyp_nemovitosti = document.getElementById('typ_subtyp_nemovitosti');
    var id_kraj = document.getElementById('id_kraj');
    var id_okres = document.getElementById('id_okres');
    var id_obec = document.getElementById('id_obec');
    var id_cobce = document.getElementById('id_cobce');


    typ_nemovitosti?.addEventListener("change", function (event) {
        setInputs(this.value);
    });

    typ_subtyp_nemovitosti?.addEventListener("change", function (event) {
        recalculate();
    });

    function setInputs(value = 0) {

        var selected = 0;
        [].forEach.call(document.getElementsByClassName('hidingN'), function (el) {
            if (el.classList.contains('N' + value)) {
                el.style.display = 'block';
            } else {
                el.style.display = 'none';
            }
        });

        if (typ_subtyp_nemovitosti?.closest('.form_select')?.getElementsByTagName('li')) {
            [].forEach.call(typ_subtyp_nemovitosti.closest('.form_select').getElementsByTagName('li'), function (el) {
                if (!typ_subtyp_nemovitosti_selected.includes(el.getAttribute('data-key'))) {
                    el.classList.remove('selected');
                }
                if (el.getAttribute('data-key').indexOf(value + '|') === 0) {
                    el.style.display = 'block';
                } else {
                    el.style.display = 'none';
                    el.classList.remove('selected');
                }
            });
        }

        if (typ_subtyp_nemovitosti?.getElementsByTagName('option')) {
            [].forEach.call(typ_subtyp_nemovitosti.getElementsByTagName('option'), function (el) {
                if (!typ_subtyp_nemovitosti_selected.includes(el.value)) {
                    el.removeAttribute('selected');
                }
                if (el.value.indexOf(value + '|') === 0) {
                    el.style.display = 'block';
                } else {
                    el.style.display = 'none';
                    el.removeAttribute('selected');
                }
            });
        }

        recalculate(selected);
    }

    function recalculate(selected = 0) {
        if (typ_subtyp_nemovitosti?.getElementsByTagName('option')) {
            [].forEach.call(typ_subtyp_nemovitosti?.getElementsByTagName('option'), function (el) {
                if (el.getAttribute('selected')) {
                    selected++;
                }
            });
        }

        if (typ_subtyp_nemovitosti?.closest('.form_select').getElementsByClassName('label-count')) {
            [].forEach.call(typ_subtyp_nemovitosti?.closest('.form_select').getElementsByClassName('label-count'), function (el) {
                el.innerHTML = selected;
            });
        }
    }

    setTimeout(function() {
        setInputs(typ_nemovitosti.value);
    }, 100);

    id_kraj?.addEventListener("change", function (event) {
        if (this.value === '19') {
            id_okres.labels[0].innerHTML = 'Pražský obvod';
            if (document.getElementById('locality-cobce')) {
                document.getElementById('locality-cobce').style.display = 'block';
            }
            if (document.getElementById('locality-obec')) {
                document.getElementById('locality-obec').style.display = 'none';
            }
        } else {
            id_okres.labels[0].innerHTML = 'Okres';
            if (document.getElementById('locality-cobce')) {
                document.getElementById('locality-cobce').style.display = 'none';
            }
            if (document.getElementById('locality-obec')) {
                document.getElementById('locality-obec').style.display = 'block';
            }
        }
        fetch('/' + window.BE_NAME + '//poptavky.php?action=ajax&type=find_okres&id_kraj=' + this.value, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {
                id_okres.innerHTML = '';
                tail?.select(id_okres).reload();

                data.okres.forEach(function(okres) {
                    tail?.select(id_okres).options.add((okres.Kod + ' '), okres.Nazev, '#', id_okres_selected.includes(okres.Kod + ' ') || tail.select(id_okres).options.length === 0, false, null, true);
                });
                id_okres?.dispatchEvent(new Event('change'));
            });
    });

    id_kraj?.dispatchEvent(new Event('change'));

    id_okres?.addEventListener("change", function (event) {
        if (id_kraj.value === '19') {
            fetch('/' + window.BE_NAME + '/poptavky.php?action=ajax&type=find_cobce&pobvod='+this.value+'&id_obec=554782', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => response.json())
                .then(data => {
                    id_cobce.innerHTML = '';
                    tail?.select(id_cobce).reload();

                    data.cobce.forEach(function (cobce) {
                        tail?.select(id_cobce).options.add((cobce.Kod + ' '), cobce.Nazev, '#', id_cobce_selected.includes(obec.Kod + ' '), false, null, true);
                    });
                });
        } else {
            fetch('/' + window.BE_NAME + '/poptavky.php?action=ajax&type=find_obec_by_okres&id_okres=' + this.value, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (id_obec) {
                        id_obec.innerHTML = '';
                        tail?.select(id_obec).reload();

                        data.obec.forEach(function (obec) {
                            tail?.select(id_obec).options.add((obec.Kod + ' '), obec.Nazev, '#', id_obec_selected.includes(obec.Kod + ' '), false, null, true);
                        });
                    }
                });
        }
    });
});